import { Chip, IconButton, Tooltip } from '@mui/material'
import { Close, Info } from '@mui/icons-material'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { selectFacet, unSelectFacet } from 'store/actions/facets'
import { resetFacetFilters } from 'store/actions/filters'
import { changeSearchText } from 'store/actions/search'

const Pills = ({
  items,
  areRemovable = true,
  selectOnClick = false,
  renderInfoSection = false
}) => {
  const dispatch = useDispatch()
  const { i18n } = useTranslation()
  const t = i18n.getResourceBundle(i18n.language)

  const handleClick = (id, name, facetType) => {
    if (selectOnClick) {
      dispatch(resetFacetFilters())
      dispatch(changeSearchText(''))
      dispatch(selectFacet({ id, name, facetType }))
    } else {
      dispatch(unSelectFacet({ id }))
    }
  }
  return (
    <div>
      {!!renderInfoSection && (
        <Tooltip
          title={
            <div className="profile-tags-list-info-tip">
              <p>{t.funder.toolTip}</p>
              <p>{t.funder.toolTipDescription}</p>
            </div>
          }
          placement="left-start"
        >
          <IconButton className="profile-tags-list-info">
            <Info aria-label="Info" />
          </IconButton>
        </Tooltip>
      )}
      <div className="profile-tags-list">
        {items.map(({ id, name, facetType }) => {
          if (facetType !== undefined) {
            return (
              <Chip
                key={id}
                onClick={() => handleClick(id, name, facetType)}
                label={name}
                icon={areRemovable && <Close />}
              />
            )
          } else {
            return (
              <Chip
                key={id}
                style={{ backgroundColor: '#ffcc33' }}
                label={name}
                icon={areRemovable && <Close />}
              />
            )
          }
        })}
      </div>
    </div>
  )
}

export default Pills
